// IMPORT PACKAGE REFERENCES
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { SmallPlus } from '../../../containers/SmallPlus';
import { ProductTypeItem } from './ProductTypeItem';

//COMPONENT
class ProductTypesSection extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            types: []
        };
    }

    componentDidMount(){
        this.setState({types: this.props.types});
    }

    componentDidUpdate(prevProps){
        if(prevProps.types != this.props.types){
            this.setState({types: this.props.types});
        }
    }

    render() {
        return (
            <div className='equipment-details-wrapper vision-card'>
                <div className="vision-card-plus-container" onClick={this.props.toggleModal}> <SmallPlus/> </div>
                <div className="vision-card-title">Supported Product Types</div>
                <div className="vision-card-subtitle">Only products of these types will be available to this equipment</div>
                {this.state.types.length > 0 && 
                    <div className="planogram-list"> 
                        {this.state.types.map((type) => {
                            return(<ProductTypeItem key={type.id} typeName={type.name} typeId={type.id} deleteTerm={'Remove'} deleteItem={this.props.removeType}/>);
                        }) }
                    </div>
                }
                {this.state.types.length == 0 && 
                    <div className="empty-list">There are no product types associated with this equipment</div>
                }
            </div>
        );
    }
}

ProductTypesSection.propTypes = {
    history: PropTypes.object.isRequired,
    types: PropTypes.array,
    toggleModal: PropTypes.func.isRequired,
    removeType: PropTypes.func.isRequired
};

const hoc = withRouter(ProductTypesSection);

// EXPORT COMPONENT
export { hoc as ProductTypesSection };


// WEBPACK FOOTER //
// ./src/components/pages/Equipment/Details/ProductTypesSection.js